export default (props, vars) =>
  vars?.['usestatestepopened']?.['state'] ? 'flex' : 'none';
